import { useEffect } from 'react';

import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import { ICardDescriptionProps } from '@/interfaces/qanty';

import './cardDescription.scss';

const CardDescription = ({ description, url, title }: ICardDescriptionProps) => {
  useEffect(() => {
    const link = document.querySelector('.a-card-description__subtitle a');
    link?.setAttribute('target', '_blank');
  }, []);

  return (
    <aside className="a-card-description">
      <figure className="a-card-description__figure">
        <img className="image" src={url} alt="alt_image" data-testid="image_card" id="image_card" />
      </figure>
      <h3 className="a-card-description__title">{title}</h3>
      <div className="a-card-description__subtitle">
        {documentToReactComponents(JSON.parse(description.raw))}
      </div>
    </aside>
  );
};

export default CardDescription;
